document.addEventListener('DOMContentLoaded',()=>{const t=document.querySelector('.menu-toggle'),n=document.querySelector('.nav');t?.addEventListener('click',()=>{const open=n.classList.toggle('open');t.setAttribute('aria-expanded',String(open))});});
// Accessible specs drawers; multiple independent sections supported.
(()=>{let active=null,trigger=null;const overlays=()=>document.querySelectorAll('[data-vc-overlay]');function close(){if(!active)return;active.classList.remove('is-open');active.setAttribute('aria-hidden','true');overlays().forEach(o=>o.hidden=true);document.body.style.overflow='';const t=trigger;active=null;trigger=null;t?.focus()}document.addEventListener('click',e=>{const open=e.target.closest('[data-vc-open]');if(open){const el=document.getElementById(open.dataset.vcOpen);if(!el)return;close();trigger=open;active=el;overlays().forEach(o=>o.hidden=false);el.classList.add('is-open');el.setAttribute('aria-hidden','false');document.body.style.overflow='hidden';el.querySelector('[data-vc-close]')?.focus();return}if(e.target.closest('[data-vc-close]')||e.target.matches('[data-vc-overlay]'))close()});document.addEventListener('keydown',e=>{if(!active)return;if(e.key==='Escape')close();if(e.key==='Tab'){const nodes=[...active.querySelectorAll('button,a[href],input,select,[tabindex]:not([tabindex="-1"])')].filter(n=>!n.disabled);if(!nodes.length)return;const first=nodes[0],last=nodes[nodes.length-1];if(e.shiftKey&&document.activeElement===first){e.preventDefault();last.focus()}else if(!e.shiftKey&&document.activeElement===last){e.preventDefault();first.focus()}}});})();

// V5: Vergrößerte Bilder behalten immer ihr Original-Seitenverhältnis.
(()=>{
 let modal=null,opener=null;
 const close=()=>{if(!modal)return;modal.hidden=true;modal.setAttribute('aria-hidden','true');document.body.style.overflow='';opener?.focus();modal=null;opener=null;};
 document.addEventListener('click',e=>{
  const thumb=e.target.closest('[data-thumb]');
  if(thumb){
   const gallery=thumb.closest('.vc-product-gallery');
   const main=gallery?.querySelector('[data-main-image]');
   if(main){
    // Shopify image_tag generates srcset; remove it so the browser uses the selected image.
    main.removeAttribute('srcset');
    main.removeAttribute('sizes');
    main.src=thumb.dataset.thumb;
    main.dataset.full=thumb.dataset.full||thumb.dataset.thumb;
    main.alt=thumb.dataset.alt||thumb.querySelector('img')?.alt||'';
    gallery.querySelectorAll('[data-thumb]').forEach(b=>b.setAttribute('aria-pressed',String(b===thumb)));
   }
   return;
  }
  const open=e.target.closest('[data-vc-zoom-open]');
  if(open){const img=open.querySelector('[data-main-image]'),m=document.querySelector('[data-vc-zoom-modal]');if(!img||!m)return;
   opener=open;modal=m;const target=m.querySelector('[data-vc-zoom-image]');target.src=img.dataset.full||img.currentSrc||img.src;target.alt=img.alt||'Produktbild';m.hidden=false;m.setAttribute('aria-hidden','false');document.body.style.overflow='hidden';m.querySelector('[data-vc-zoom-close]')?.focus();return;
  }
  if(modal&&(e.target.closest('[data-vc-zoom-close]')||e.target===modal))close();
 });
 document.addEventListener('keydown',e=>{if(modal&&e.key==='Escape')close();});
})();

// V8: Synchronisiere Shopify-Varianten mit der Produktgalerie.
// Jedes Variant-Bild stammt direkt aus dem Shopify-Produktdatensatz.
(()=>{
 function updateVariant(select){
  const option=select.selectedOptions?.[0];
  const details=select.closest('.product-details');
  const layout=select.closest('.product-layout');
  const gallery=layout?.querySelector('.vc-product-gallery');
  if(!option||!gallery)return;
  const price=details?.querySelector('[data-vc-product-price]');
  if(price&&option.dataset.variantPrice)price.textContent=option.dataset.variantPrice;
  const sku=document.querySelector('[data-vc-variant-sku]');
  if(sku)sku.textContent=option.dataset.variantSku||'—';
  const src=option.dataset.variantImage;
  if(!src)return; // Varianten ohne zugeordnetes Bild behalten das bisherige Bild.
  const main=gallery.querySelector('[data-main-image]');
  if(!main)return;
  main.removeAttribute('srcset');main.removeAttribute('sizes');
  main.src=src;
  main.dataset.full=option.dataset.variantFull||src;
  main.alt=option.dataset.variantAlt||'';
  const thumbs=gallery.querySelectorAll('[data-thumb]');
  let matching=null;
  thumbs.forEach(t=>{
   const match=option.dataset.variantImageId && t.dataset.imageId===option.dataset.variantImageId;
   t.setAttribute('aria-pressed',String(Boolean(match)));
   if(match)matching=t;
  });
  matching?.scrollIntoView({block:'nearest',inline:'nearest',behavior:'smooth'});
 }
 document.addEventListener('change',e=>{
  if(e.target.matches('[data-vc-variant-select]'))updateVariant(e.target);
 });
 // URL-basierte Variantenwahl beim Laden unterstützen.
 document.addEventListener('DOMContentLoaded',()=>{
  document.querySelectorAll('[data-vc-variant-select]').forEach(select=>{
   const id=new URLSearchParams(location.search).get('variant');
   if(id&&[...select.options].some(o=>o.value===id))select.value=id;
   updateVariant(select);
  });
 });
})();
